import { connect } from 'react-redux';
import { closeSideBar, getParams } from '../../../../store/sidebar';
import SenderIdView, { DispatchPropsType, MapStatePropsType } from '../organisms/senderId/senderIdView';
import { openSideBar } from '../../../../store/sidebar';
import { Instances, SideBarTypes } from '../../../../constants';
import { IStateType } from '../../../../store/models/root.interface';
import { makeSelectInProgress } from '../../../../store/Object';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { getDataById } from '../../../../store/actions/smsSenderId.action';

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => dispatch(closeSideBar()),
    onEdit: (param: any) => dispatch(openSideBar(SideBarTypes.senderIdEditForm, { id: param.id })),
    onLoadDataById: (param: any) => dispatch(getDataById(param.id)),
});

const mapStateToProps = (state: IStateType) => ({
    params: getParams(state),
    senderIdDetails: state.senderId.senderIdDataById,
    inProgress: makeSelectInProgress(Instances.smsSenderIdView)(state),
    userProfile: state.profile
});

export default connect<MapStatePropsType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(SenderIdView));